import { Component, Inject, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { LogisticaService } from '../services/logistica.service';
import { showSpinner, hideSpinner, getCurrentUser } from 'src/app/core/services/functions.service';
import { NotificationHelper } from 'src/app/core/services/helpers/notification.helper';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalAlertasComponent } from '../modal-alertas/modal-alertas.component';

@Component({
  selector: 'app-modal-capacidad-dias',
  templateUrl: './modal-capacidad-dias.component.html',
  styleUrls: ['./modal-capacidad-dias.component.scss']
})
export class ModalCapacidadDiasComponent implements OnInit {
  capacidadesDias: any[] = [];
  dataSource: MatTableDataSource<any>;
  displayedColumns: string[] = ['ID_REG_CAL', 'COD_BODEGA', 'FECHA_DIA', 'CUBICAJE_TOTAL', 'CANTIDAD_ORD_TOTAL', 'CIERRE_AUTOMATICO', 'PORCENTAJE_CIERRE', 'ESTADO', 'USUARIO_CREACION','ACCIONES'];

  rowEnEdicion: string | null = null;
  editForm: { FECHA_DIA: string; CUBICAJE_TOTAL: number; CANTIDAD_ORD_TOTAL: number; CIERRE_AUTOMATICO: string; PORCENTAJE_CIERRE: number } = {
    FECHA_DIA: '', CUBICAJE_TOTAL: 0, CANTIDAD_ORD_TOTAL: 0, CIERRE_AUTOMATICO: 'S', PORCENTAJE_CIERRE: 97
  };

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('editDiaDialog') editDiaDialogTpl!: TemplateRef<any>;
  private editDiaDialogRef: MatDialogRef<any> | null = null;

  constructor(
    public dialogRef: MatDialogRef<ModalCapacidadDiasComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private logisticaService: LogisticaService,
    private notificationService: NotificationHelper,
    private dialog: MatDialog
  ) {
    this.dataSource = new MatTableDataSource<any>([]);
  }

  async ngOnInit() {
    await this.cargarCapacidadesDias();
  }

  async cargarCapacidadesDias() {
    try {
      showSpinner();
      console.log('Cargando capacidades por días para ID_POLI:', this.data.ID_POLI);
      
      // Intentar usar el servicio específico para capacidades por días
      let response;
      try {
        response = await this.logisticaService.obtener_capacidades_dias(this.data.ID_POLI, this.data.COD_BODEGA);
      } catch (error) {
        // Si falla, usar el servicio general y filtrar
        console.log('Usando servicio general como fallback');
        response = await this.logisticaService.obtener_capacidades(this.data.ID_POLI);
      }
      
      if (response && response.success) {
        // Si viene del servicio general, filtrar solo las capacidades por días
        if (response.data && response.data.length > 0 && response.data[0].ID_REG) {
          this.capacidadesDias = (response.data || []).filter((item: any) => item.ID_REG_CAL);
        } else {
          this.capacidadesDias = response.data || [];
        }
        this.dataSource = new MatTableDataSource<any>(this.capacidadesDias);
        this.dataSource.paginator = this.paginator;
      } else if (!response?.success) {
        this.notificationService.errorMessage(response?.message || "Error al cargar las capacidades por días");
      }
    } catch (error) {
      console.error('Error al cargar capacidades por días:', error);
      this.notificationService.errorMessage("Error al cargar las capacidades por días");
    } finally {
      hideSpinner();
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-CO', {
      day: '2-digit',
      month: '2-digit', 
      year: 'numeric'
    });
  }

  formatDateTime(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleString('es-CO', {
      day: '2-digit',
      month: '2-digit', 
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  iniciarEdicion(element: any): void {
    this.rowEnEdicion = element.ID_REG_CAL;
    this.editForm = {
      FECHA_DIA: element.FECHA_DIA ? element.FECHA_DIA.substring(0, 10) : '',
      CUBICAJE_TOTAL: element.CUBICAJE_TOTAL || 0,
      CANTIDAD_ORD_TOTAL: element.CANTIDAD_ORD_TOTAL || 0,
      CIERRE_AUTOMATICO: element.CIERRE_AUTOMATICO || 'S',
      PORCENTAJE_CIERRE: element.PORCENTAJE_CIERRE || 97
    };
    this.editDiaDialogRef = this.dialog.open(this.editDiaDialogTpl, {
      width: '520px',
      disableClose: true,
      autoFocus: true
    });
  }

  cancelarEdicion(): void {
    this.editDiaDialogRef?.close();
    this.rowEnEdicion = null;
  }

  async guardarEdicion(): Promise<void> {
    if (!this.rowEnEdicion) return;
    try {
      showSpinner();
      const usuario = getCurrentUser()?.usuario_aplicativo || '';
      const elemento = this.capacidadesDias.find(d => d.ID_REG_CAL === this.rowEnEdicion);
      const res = await this.logisticaService.update_capacidades_por_dia(
        String(this.rowEnEdicion),
        String(elemento?.COD_BODEGA || ''),
        this.editForm.CIERRE_AUTOMATICO,
        this.editForm.PORCENTAJE_CIERRE,
        this.editForm.CUBICAJE_TOTAL,
        this.editForm.CANTIDAD_ORD_TOTAL,
        this.editForm.FECHA_DIA,
        usuario
      );
      if (res.success) {
        this.notificationService.successMessage(res.message || 'Capacidad por día actualizada correctamente.');
        // Actualizar localmente sin llamar el endpoint de recarga
        const idx = this.capacidadesDias.findIndex(d => d.ID_REG_CAL === this.rowEnEdicion);
        if (idx !== -1) {
          const usuario = getCurrentUser()?.usuario_aplicativo || '';
          this.capacidadesDias[idx] = {
            ...this.capacidadesDias[idx],
            FECHA_DIA: this.editForm.FECHA_DIA,
            CIERRE_AUTOMATICO: this.editForm.CIERRE_AUTOMATICO,
            PORCENTAJE_CIERRE: this.editForm.PORCENTAJE_CIERRE,
            CUBICAJE_TOTAL: this.editForm.CUBICAJE_TOTAL,
            CANTIDAD_ORD_TOTAL: this.editForm.CANTIDAD_ORD_TOTAL,
            USUARIO_MODIFICACION: usuario
          };
          this.dataSource = new MatTableDataSource<any>([...this.capacidadesDias]);
          this.dataSource.paginator = this.paginator;
        }
        this.editDiaDialogRef?.close();
        this.rowEnEdicion = null;
      } else {
        this.notificationService.errorMessage(res.message || 'Error al actualizar la capacidad por día.');
      }
    } catch (error) {
      this.notificationService.errorMessage('Error al actualizar la capacidad por día.');
    } finally {
      hideSpinner();
    }
  }

  confirmarEliminarDia(element: any): void {
    this.notificationService.warningDialog(
      'Confirmar eliminación',
      '¿Está seguro de eliminar esta capacidad por día? Esta acción no se puede deshacer.',
      'Aceptar',
      () => this.eliminarCapacidadDia(element),
      '450px'
    );
  }

  async eliminarCapacidadDia(element: any): Promise<void> {
    try {
      showSpinner();
      const res = await this.logisticaService.eliminar_capacidad_por_dia(String(element.ID_REG_CAL));
      if (res.success) {
        this.notificationService.successMessage(res.message || 'Capacidad por día eliminada correctamente.');
        // Eliminar localmente sin llamar el endpoint de recarga
        this.capacidadesDias = this.capacidadesDias.filter(d => d.ID_REG_CAL !== element.ID_REG_CAL);
        this.dataSource = new MatTableDataSource<any>(this.capacidadesDias);
        this.dataSource.paginator = this.paginator;
      } else {
        this.notificationService.errorMessage(res.message || 'Error al eliminar la capacidad por día.');
      }
    } catch (error) {
      this.notificationService.errorMessage('Error al eliminar la capacidad por día.');
    } finally {
      hideSpinner();
    }
  }

  abrirModalAlertas(element: any) {
    const dialogConfig = new MatDialogConfig();
    // Asegurar que se pase el ID correcto para las alertas
    const dataParaModal = {
      ...element,
      ID_REG_CAPAC: element.ID_REG || element.ID_REG_CAL
    };
    dialogConfig.data = dataParaModal;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '800px';
    dialogConfig.height = 'fit-content';
    
    const dialogRef = this.dialog.open(ModalAlertasComponent, dialogConfig);
    
    dialogRef.afterClosed().subscribe(result => {
      console.log('Modal de alertas cerrado');
    });
  }

}